import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/LatheGeometry'

export default meshComponent('Lathe', props, createGeometry)
